
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluIsyeriSgkCevap } from '@/plugins/uyap-plugin/uyap/DosyaBorcluIsyeriSgk';

@Component({})
export default class IsyeriDetay extends Vue {
  @Prop() data!: DosyaBorcluIsyeriSgkCevap;

  yoneticiHeaders = [
    { text: 'Ad Soyad', value: 'tyad' },
    { text: 'TC Kimlik', value: 'tymernisno' },
    { text: 'Doğum', value: 'tydogumtarih' },
    { text: 'Baba Adı', value: 'tybabaad' },
    { text: 'Anne Adı', value: 'tyanaad' },
    { text: 'Ünvan', value: 'tyykodaciklama' }
  ];

  // DEV-3354: UYAP "Adalet" zarfına geçti (bkz. icrapro-laravel-api DEV-2248);
  // liste isYeriBilgi.data.isyerleri altında ve TE_*/TY_* alanları küçük harfe indi.
  get isyeriList() {
    return this.data.sorguSonucDVO?.isYeriBilgi?.data?.isyerleri || [];
  }
}
